import React from "react";
import { Image, Platform } from "react-native";
import AppTheme from "../../utils/Theme";
import View from "../ReactNative/View";
import { useSpecificSize } from "../../../specific/Theme/SpecificSize";

interface NavigationBarHeaderProps {
    image: { uri: string } | number;
    backgroundColor?: string;
}

const NavigationBarHeader = (props: NavigationBarHeaderProps) => {
    const { image, backgroundColor = "transparent" } = props;

    const {
        fullScreenWidth,
        fullScreenHeight,
        availableScreenSize,
        contentSize,
        sideMenuSize,
        horizontalSpacing
    } = useSpecificSize();

    const header_image_height: number = Platform.OS === "web" ? availableScreenSize * 700 / 3840 : availableScreenSize * 1120 / 2880;
    return <Image source={image} style={{ width: availableScreenSize, height: header_image_height, backgroundColor }} />
}

export default NavigationBarHeader;